<template>
  <span>{{ groupTag }}({{ username }})</span>
</template>

<script>
export default {
  props: {
    row: Object,
  },
  computed: {
    groupTag() {
      return this.$t("column.l" + this.row.group);
    },
    username() {
      return this.row.username;
    },
  },
};
</script>
